// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___1JaHq","tableBorder":"styles__tableBorder___3WMYe"};